import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getAuditDocument } from "api/thunk/auditDocuments/getActions/getAuditDocument";
import { deleteAuditDocument } from "api/thunk/auditDocuments/deleteActions/deleteAuditDocument";
import { postAuditDocumentMarkAsRead } from "api/thunk/auditDocuments/postActions/postAuditDocumentMarkAsRead";
import { AuditTab } from "./types";

const auditDocumentsSlice = createSlice({
  name: "auditDocuments",
  initialState,
  reducers: {
    setAuditDocumentPage: (state, action: PayloadAction<{ tab: AuditTab; page: number }>) => {
      const { tab, page } = action.payload;
      state.auditDocument[tab].params.page = page;
    },
    setAuditDocumentPageSize: (state, action: PayloadAction<{ tab: AuditTab; pageSize: number }>) => {
      const { tab, pageSize } = action.payload;
      state.auditDocument[tab].params.pageSize = pageSize;
    },
    setAuditDocumentParams: (state, action: PayloadAction<{ tab: AuditTab; params: Partial<typeof state.auditDocument[AuditTab]['params']> }>) => {
      const { tab, params } = action.payload;
      state.auditDocument[tab].params = { ...state.auditDocument[tab].params, ...params };
    },
  },
  extraReducers: (builder) => {
    builder
      //get_audit_document
      .addCase(getAuditDocument.pending, (state, action) => {
        const tab = action.meta.arg.tab;
        state.auditDocument[tab].response.loading = true;
        state.auditDocument[tab].response.error = null;
      })
      .addCase(getAuditDocument.fulfilled, (state, action) => {
        const { tab, data } = action.payload;
        state.auditDocument[tab].response.loading = false;
        state.auditDocument[tab].response.data = data;
      })
      .addCase(getAuditDocument.rejected, (state, action) => {
        const tab = action.meta.arg.tab;
        state.auditDocument[tab].response.loading = false;
        state.auditDocument[tab].response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //delete_audit_document
      .addCase(deleteAuditDocument.pending, (state) => {
        state.deleteAuditDocument.loading = true;
        state.deleteAuditDocument.error = null;
      })
      .addCase(deleteAuditDocument.fulfilled, (state, action) => {
        state.deleteAuditDocument.loading = false;
        state.deleteAuditDocument.data = action.payload;
      })
      .addCase(deleteAuditDocument.rejected, (state, action) => {
        state.deleteAuditDocument.loading = false;
        state.deleteAuditDocument.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //post_audit_document_mark_as_read
      .addCase(postAuditDocumentMarkAsRead.pending, (state) => {
        state.postAuditDocumentMarkAsRead.loading = true;
        state.postAuditDocumentMarkAsRead.error = null;
      })
      .addCase(postAuditDocumentMarkAsRead.fulfilled, (state, action) => {
        state.postAuditDocumentMarkAsRead.loading = false;
        state.postAuditDocumentMarkAsRead.data = action.payload;
      })
      .addCase(postAuditDocumentMarkAsRead.rejected, (state, action) => {
        state.postAuditDocumentMarkAsRead.loading = false;
        state.postAuditDocumentMarkAsRead.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      });
  },
});


export const { setAuditDocumentPage, setAuditDocumentPageSize, setAuditDocumentParams } = auditDocumentsSlice.actions;
export default auditDocumentsSlice.reducer;
